<template>
  <div class="d-flex form-wrapper">
    <b-row class="w-100" v-if="subServices.length > 0">
      <b-col cols="12" class="mx-auto">
        <validation-observer ref="saveService" v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(saveService)">
            <b-form-group label-for="vi-service_name" class="required">
              <validation-provider
                #default="{ errors }"
                name="Services"
                vid="vi-service_id"
                :rules="{ required: true }"
              >
                <b-form-checkbox-group
                  v-model="form.service_id"
                  name="service_id"
                >
                  <b-row>
                    <b-col
                      v-for="option in subServices"
                      :key="option.id"
                      cols="12"
                      md="6"
                      class="my-1"
                    >
                      <b-form-checkbox :value="option.id" class="w-100">
                        {{ option.service_name }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form-checkbox-group>

                <small class="text-danger d-block">{{ t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <div class="text-center">
              <b-button type="submit" variant="success" class="mt-2">
                {{ t('Assign') }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
    <b-row class="w-100" v-if="subServices.length <= 0">
      <b-col cols="12" class="mx-auto">
        <div class="text-center">
          {{ t('No Sub Service Found') }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCol, BRow, BFormGroup } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { useUtils } from '@core/libs/i18n'
import store from '@/store'
import constants from '@/constants'
import { hideLoader, showLoader } from '@/utils/common'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'OpportunitySubServices',
  components: {
    BRow,
    ValidationProvider,
    ValidationObserver,
    BCol,
    BFormGroup,
  },
  props: {
    services: {
      type: Number,
      required: true,
    },
    opportunityData: {
      type: Object,
      default: () => {},
      require: true,
    },
    leadId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      constants,
      loginUser: JSON.parse(localStorage.getItem('userData')).companyuserid,
      usersListFlag: true,
      assignServiceCollapse: false,
      subServices: [],
      form: {
        service_id: [],
        opportunity_id: 0,
        lead_id: 0,
      },
    }
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  mounted() {
    this.form.opportunity_id = this.opportunityData.lead_opportunity_id
    this.form.lead_id = this.leadId

    this.collapseAssign()
  },
  methods: {
    async collapseAssign() {
      showLoader()
      await this.getOpportunitySubServicesList()
      await this.getLeadOpportunityService()
      hideLoader()
    },
    async getOpportunitySubServicesList() {
      await store
        .dispatch('opportunityStore/opportunitySubServicesList', {
          parent_id: this.services,
        })
        .then(response => {
          // eslint-disable-next-line eqeqeq
          if (response.data.code == constants.SUCCESS) {
            this.subServices = response.data.data
          }
        })
    },
    async getLeadOpportunityService() {
      await store
        .dispatch('opportunityStore/getLeadOpportunityService', {
          opportunity_id: this.form.opportunity_id,
        })
        .then(response => {
          // eslint-disable-next-line eqeqeq
          if (response.data.code == constants.SUCCESS) {
            this.form.service_id = response.data.data.service_ids
          }
        })
    },
    async saveService() {
      try {
        showLoader()

        const response = await store.dispatch(
          'opportunityStore/saveLeadOpportunityService',
          this.form // eslint-disable-line comma-dangle
        )
        const isSuccess = response.data.code === +constants.SUCCESS
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: response.data.msg,
            icon: isSuccess ? 'Success' : 'Danger',
            variant: isSuccess ? 'success' : 'danger',
          },
        })
        this.getLeadOpportunityService()
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something went wrong!',
            icon: 'Danger',
            variant: 'danger',
          },
        })
      } finally {
        hideLoader()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-card-fixed-height {
  height: 320px;
  margin-bottom: 10px;
}
.tab-card-fixed-height::-webkit-scrollbar {
  display: none;
}
.vs__dropdown-menu {
  max-height: 50px !important;
}
.form-wrapper {
  height: 100vh;
  padding: 20px;
}
</style>
